// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"353":"4f58a842","641":"1260244c","802":"e3b4b1b8"}[chunkId] + ".chunk.css";
};